import {
  CreateDistrictAdminRequest,
  DistrictAdminsIdsListRequest,
  SaveOnboardingRequest,
  UpdateDistrictAdminRequest
} from "../../../../types/gqlTypes/graphql"
import { executeMutationSideload } from "../../helpers/studyPlan"
import {
  CREATE_DISTRICT_ADMIN,
  DELETE_DISTRICT_ADMINS,
  DISTRICT_ADMIN_SAVE_ONBOARDING,
  UPDATE_DISTRICT_ADMIN
} from "./orgDistrictAdminMutations"

export function createDistrictAdmin(
  data: CreateDistrictAdminRequest
): Promise<boolean> {
  return executeMutationSideload(CREATE_DISTRICT_ADMIN, { data })
}

export function updateDistrictAdmin(
  data: UpdateDistrictAdminRequest
): Promise<boolean> {
  return executeMutationSideload(UPDATE_DISTRICT_ADMIN, { data })
}

export function deleteDistrictAdmins(
  data?: DistrictAdminsIdsListRequest
): Promise<boolean> {
  return executeMutationSideload(DELETE_DISTRICT_ADMINS, { data })
}

export function districtAdminSaveOnboarding(
  data?: SaveOnboardingRequest
): Promise<boolean> {
  return executeMutationSideload(DISTRICT_ADMIN_SAVE_ONBOARDING, { data })
}
